import React, { Component } from 'react';
import { OrderSheetData } from '../../../api/models/OrderSheetData';
import { Grid, Typography, Button } from '@material-ui/core';
import { withRouter, RouteComponentProps } from 'react-router';

import { IMAGES_URL } from '../../../api/client';
import { roundedCorners } from '../../../QmoTheme';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

type Props = {
    orderSheets: OrderSheetData[],
    setCurrentOrderSheet: (orderSheetId: number) => void,
} & RouteComponentProps<any>

type State = {
    imagesLoadedCount: number,
}

const style : CSSProperties = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                minWidth: '290px', 
                maxHeight: '140px', 
                position: 'relative'
}

const OrderSheetWidgetItem = (props: any) => {
    let { orderSheet, openOrderSheet } = props
    return (
        <Grid item xs={12} sm={6} md={4} style={{ padding: '4px' }}>

            <div style={Object.assign({}, style, roundedCorners)}>

                <img alt="" style={{ flexShrink: 0, maxWidth: '100%', maxHeight: '100%' }} src={IMAGES_URL + (orderSheet as OrderSheetData).image} />

                <div style={{ position: 'absolute', bottom: 0, width: "100%", backgroundColor: "rgb(255, 255, 255, 0.8)", textAlign: 'left', padding: '10px' }}>
                    <Grid container alignItems="center">
                        <Grid item xs={8} sm={8}>
                            <div style={{ display: 'inline-block' }}><Typography variant='h3'>{orderSheet.name}</Typography></div>
                            <div style={{ display: 'inline-block' }}>&nbsp;({orderSheet.items.length} products)</div>
                        </Grid>

                        <Grid item xs={4} sm={4} style={{ textAlign: 'right' }}>
                            <Button onClick={() => openOrderSheet(orderSheet.id)} color="primary" variant="outlined" style={{ minWidth: '75px' }}>Open</Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </Grid>
    )
}

class OrderSheetsWidget extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            imagesLoadedCount: 0
        }

        this.openOrderSheet = this.openOrderSheet.bind(this)
    }

    preloadImages = () => {
        for (let os of this.props.orderSheets) {
            let img = new Image()
            img.src = IMAGES_URL + os.image
            img.onload = () => {
                this.setState((prevState, props) => ({
                    imagesLoadedCount: prevState.imagesLoadedCount + 1
                }));
            }
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.orderSheets.length !== this.props.orderSheets.length)
            this.preloadImages()
    }

    componentDidMount() {
        if(this.props.orderSheets.length > 0)
            this.preloadImages()
    }

    openOrderSheet(orderSheetId: number) {
        this.props.setCurrentOrderSheet(orderSheetId)
        this.props.history.push("/Search")
    }

    renderOrderSheets(orderSheets: OrderSheetData[]) {
        if (orderSheets.length > 0) {
            return (
                <Grid container alignContent="center">
                    {orderSheets.map((os, i) => {
                        return <OrderSheetWidgetItem key={i} orderSheet={os} openOrderSheet={this.openOrderSheet} />
                    })}
                </Grid>
            );
        }
    }

    render() {
        //console.log('os count: ' + this.props.orderSheets.length + '   Loaded:' + this.state.imagesLoadedCount)
        return (
            <div style={{ textAlign: 'center' }}>
                {this.state.imagesLoadedCount === this.props.orderSheets.length &&
                    <div>
                        {this.renderOrderSheets(this.props.orderSheets)}
                    </div>
                }
            </div>
        );
    }
}

export default withRouter(OrderSheetsWidget);